import jwt_decode from 'jwt-decode';

// Token storage keys
const ACCESS_TOKEN_KEY = 'weeshsong_access_token';
const REFRESH_TOKEN_KEY = 'weeshsong_refresh_token';
const USER_KEY = 'weeshsong_user';

interface DecodedToken {
  exp: number;
  [key: string]: any;
}

// Get current user from localStorage
export const getCurrentUser = () => {
  const userStr = localStorage.getItem(USER_KEY);
  if (!userStr) return null;

  try {
    return JSON.parse(userStr);
  } catch (error) {
    localStorage.removeItem(USER_KEY);
    return null;
  }
};

// Get access token from localStorage
export const getCurrentToken = () => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

// Save auth tokens and user data
export const setAuthData = (accessToken: string, refreshToken: string, userData: any) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  localStorage.setItem(USER_KEY, JSON.stringify(userData));
};

export const setAccessToken = (accessToken: string) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
};

// Update user data
export const updateUserData = (userData: any) => {
  const currentUser = getCurrentUser();
  if (currentUser) {
    localStorage.setItem(USER_KEY, JSON.stringify({
      ...currentUser,
      ...userData
    }));
  }
};

// Remove auth data (logout)
export const logout = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// Check if token is expired
export const isTokenExpired = (token: string) => {
  try {
    const decoded = jwt_decode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (error) {
    return true;
  }
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = getCurrentToken();
  if (!token) return false;

  return !isTokenExpired(token);
};

// Get refresh token
export const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};
